import type { AppRouteConfig } from '../../models'
import { FeatureIdEnum } from '../../enums'
import UserRoleManagement from '../../views/user-role-management.view.vue'
import { ROUTER_CONSTS } from '../router.consts'

export const USER_ROLE_MANAGEMENT_ROUTES: Array<AppRouteConfig> = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.USER_ROLE_MANAGEMENT],
    path: 'userRoleManagement',
    component: UserRoleManagement,
    meta: {
      featureId: FeatureIdEnum.USER_ROLE_MANAGEMENT,
    },
  },
]
